import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

const FavoritesContext = createContext();

export const useFavorites = () => useContext(FavoritesContext);

// Favorites are namespaced per user (or "guest") so signing in/out swaps lists.
const keyFor = (user) => `pixiy-favorites-${user?.uid || 'guest'}`;

export const FavoritesProvider = ({ children }) => {
    const { user } = useAuth();
    const [favorites, setFavorites] = useState([]);

    // Load the right list whenever the signed-in user changes.
    useEffect(() => {
        try {
            const raw = localStorage.getItem(keyFor(user));
            setFavorites(raw ? JSON.parse(raw) : []);
        } catch {
            setFavorites([]);
        }
    }, [user]);

    const persist = (list) => {
        try {
            localStorage.setItem(keyFor(user), JSON.stringify(list));
        } catch {
            /* ignore quota / serialization errors */
        }
    };

    const isFavorite = (kind, id) =>
        favorites.some((f) => f.kind === kind && f.id === id);

    const toggleFavorite = (kind, item) => {
        setFavorites((prev) => {
            const exists = prev.some((f) => f.kind === kind && f.id === item.id);
            const next = exists
                ? prev.filter((f) => !(f.kind === kind && f.id === item.id))
                : [{ kind, id: item.id, item }, ...prev];
            persist(next);
            return next;
        });
    };

    return (
        <FavoritesContext.Provider
            value={{ favorites, isFavorite, toggleFavorite, count: favorites.length }}
        >
            {children}
        </FavoritesContext.Provider>
    );
};

export default FavoritesContext;
